document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('media-gallery');

  galleries.forEach((gallery) => {
    const slides = gallery.querySelectorAll('.product__media-item');

    if (!slides.length) return;

    const prepareVideo = (video) => {
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');

      video.removeAttribute('controls');
    };

    const playSlide = (slide) => {
      if (!slide) return;

      const deferredMedia = slide.querySelector('deferred-media');

      if (!deferredMedia) return;

      // Załaduj film, jeżeli nadal widoczny jest tylko poster.
      if (!deferredMedia.hasAttribute('loaded')) {
        if (typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      // loadContent tworzy <video>, więc dajemy DOM chwilę.
      requestAnimationFrame(() => {
        const video = deferredMedia.querySelector('video');

        if (!video) return;

        prepareVideo(video);

        const promise = video.play();

        if (promise) {
          promise.catch(() => {});
        }
      });
    };

    const pauseSlide = (slide) => {
      const video = slide.querySelector('video');

      if (video && !video.paused) {
        video.pause();
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.6) {
            playSlide(entry.target);
          } else {
            pauseSlide(entry.target);
          }
        });
      },
      {
        root: gallery.querySelector('.product__media-list'),
        threshold: [0, 0.25, 0.6, 0.8, 1]
      }
    );

    slides.forEach((slide) => observer.observe(slide));
  });
});